import * as React from 'react';
import { DataGrid, GridToolbarExport,
	GridToolbarContainer } from '@mui/x-data-grid';
import Breadcrumb from '../Components/Breadcrumb';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import './Agentdashboard.css';
import axios from 'axios';
//import React, { Component, useState } from "react";

const columns = [
{ field: 'id', headerName: 'No', width: 95 },
{ field: 'date', headerName: 'Date', width: 210 },
{ field: 'name', headerName: 'CustomerName', width: 210 },
{ field: 'customeramount', headerName: 'CustomerAmount', width: 210 },
{ field: 'youramount', headerName: 'YourAmount', width: 210 },
{ field: 'deliverycharge', headerName: 'DeliveryCharge', width: 210 },
{ field: 'earnings', headerName: 'Earnings', width: 210 },
];




const rows = [
	
{ id: 1, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 2, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 3, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 4, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 5, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 6, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 7, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 8, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 9, date:"29/Apr/2022", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
{ id: 10, date:"2019-09-13", name:"akshay", customeramount: "120.0", youramount: '150.0', deliverycharge:"130.010", earnings:"170.00" },
];

function MyExportButton() {
return (
	<GridToolbarContainer>
	<GridToolbarExport />
	</GridToolbarContainer>
);
}
async function agentData() {
	const USR_TOKEN = localStorage.getItem('userToken')

    return axios.get(encodeURI(process.env.REACT_APP_API_URL + 'api/method/ecom.api.agent_orders?date=2022-05-23'), {
		headers : {'Authorization' : USR_TOKEN, 
	'content-type': 'application/json'}
	})
	
	  .then(function (response) {
		//console.log(response.data.message);
		return response.data.message
		
		//console.log(agent)
	  })
	  .catch(function (error) {
		  return error
		//console.log(error);
		//alert("ok")
	  })

}

export default function App() {
	
	//console.log(rowss)
	const USR_TYPE = localStorage.getItem("userType")
	const [value, setValue] = React.useState(new Date());
	
	
	//const axios = require('axios');
	
	//let data = this. agentData();
	
	
	
	agentData().then(function(result) {

		var i = 0 ;
		var agent = {
			customerData: []
			
		};
		for(var i in result) {    

			var item = result[i];   
		
			agent.customerData.push({ 
				"id" : parseInt(i)+1,
				"date": item.creation,
				"name" : item.customer_name,
				"customeramount" : item.total,
				"youramount" : 0,
				"deliverycharge" : 0,
				"earnings" : item.amount_eligible_for_commission,
			});
		}
		console.log(result); // "initResolve"
		return "normalReturn";
	  })
	//console.log()
if( USR_TYPE === 'agent')		
return (<div>
		<Breadcrumb head="Agent Dashboard"/>
		<div className="container-fluid">
			<div className="date-picker res-date-picker">
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<DatePicker
      					label="Select Date"
      					value={value}
      					inputFormat="dd MMM yyyy"
      					onChange={(e) => {
        				console.log(e);
        				setValue(e);
     					 }}
      					renderInput={(params) => <TextField {...params} fullWidth />}
    				/>
    			</LocalizationProvider>
			</div>
		</div>
		<div className="container mt-3">
			<h4 className="mb-2 ">My Dashboard</h4>
			<div className="row mb-3">
				<div className="dashboard">
					<div className="card">
						<h3 className="mb-2">0</h3>
						<p>Today's Sales</p>
					</div>
				</div>
				<div className="dashboard">
					<div className="card">
						<h3 className="mb-2">0</h3>
						<p>Today's Sale Amount</p>
					</div>
				</div>
				<div className="dashboard">
					<div className="card">
						<h3 className="mb-2">0</h3>
						<p>Today's Earnings</p>
					</div>
				</div>
			</div>
			<div className="mb-5 " style={{ height: 400, width: '100%' }}>
				<h4 className="mb-2">Recent Transactions</h4>
				<DataGrid rows={rows} columns={columns}
					pageSize={50}
					components={{
					Toolbar: MyExportButton,
					}}
				/>
			</div>
  		</div>
  </div>
)
else 
return ""
}
